// @flow
import React, { Component } from "react";

import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

import { GeneralModalForm } from "imagus-components";
import CreateTierFormRedux from "../../containers/quotes/CreateTierFormRedux";

type TierItemPropsType = {
  tier: { [key: string]: * }
};

type TierItemStatesType = {
  modalOpen: boolean
};

class TierItem extends Component<TierItemPropsType, TierItemStatesType> {
  constructor(props: TierItemPropsType) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  render(): React$Element<*> {
    const tier = this.props.tier;
    return (
      <Grid item xs={12} md={6}>
        <Table className="app-table center light-border">
          <TableHead>
            <TableRow className="active">
              <TableCell className="border" colSpan={4}>
                <span>{tier.name}</span>
                <IconButton
                  aria-label="Edit"
                  onClick={(): * => this.switchModalStatus(true)}
                >
                  <EditIcon className="shine-icon" />
                </IconButton>
                <GeneralModalForm
                  title={"Update " + tier.name}
                  open={this.state.modalOpen}
                  handleModalStatus={this.switchModalStatus}
                  form={
                    <CreateTierFormRedux
                      onClose={(): * => this.switchModalStatus(false)}
                      tier={tier}
                    />
                  }
                />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell padding="dense" rowSpan={4}>
                Discounts
              </TableCell>
              <TableCell padding="dense" rowSpan={2}>
                Authorised
              </TableCell>
              <TableCell padding="dense">Distributer</TableCell>
              <TableCell padding="dense" className="border">
                {tier.discounts.authorised.distributer}%
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell padding="dense">Reseller</TableCell>
              <TableCell padding="dense" className="border">
                {tier.discounts.authorised.reseller}%
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell padding="dense" rowSpan={2}>
                Standard
              </TableCell>
              <TableCell padding="dense">Distributer</TableCell>
              <TableCell padding="dense" className="border">
                {tier.discounts.standard.distributer}%
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell padding="dense">Reseller</TableCell>
              <TableCell padding="dense" className="border">
                {tier.discounts.standard.reseller}%
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    );
  }
}

export default TierItem;
